<template>
  <div>
    <h2 class="diviser">
      Registros de vistoria
    </h2>

    <div class="m-t">
      <u-table
          ref="table"
          color="primary"
          :data="table.serverData"
          :columns="table.columns"
          :visible-columns="visibledColumns"
          :filter="table.busca"
          row-key="id"
          :pagination.sync="table.serverPagination"
          @request="request"
          selection="multiple"
          :selected.sync="table.selected"
          :loading="table.loading"
          class="sl-table no-bottom no-scroll m-t-md"
          :rows-per-page-options="[20, 50, 100]"
          :hide-no-results-label="true"
      >
        <u-tr slot="header" slot-scope="props">
          <u-th v-for="col in props.cols" :key="col.name" :style="col.name === 'motivo' ? 'text-align: right !important' : ''" :props="props">
            <template>
              {{ col.label }}
            </template>
            <div v-if="col.name === 'options'" class="text-right">
              <span class="cursor-pointer" @click="listOptions">Opções</span>
            </div>
          </u-th>
        </u-tr>

        <u-tr v-on:dblclick.native="abrir(props.row.id)" slot="body" slot-scope="props"
              :props="props" :class="{'u-table-item-destac': props.row.isToday}">
          <!--          <u-td auto-width>
                      <u-checkbox color="primary" v-model="props.selected" size="xs"/>
                    </u-td>-->
          <u-td key="origem" :props="props">
            {{ props.row.origem || 'Aguardando vistoria' }}
          </u-td>
          <u-td key="data" :props="props">
            {{ props.row.createdAt|formatDate }}
          </u-td>
          <u-td key="vistoriador" :props="props">
            {{ props.row.vistoriador ? props.row.vistoriador.name : '-' }}
          </u-td>
          <u-td class="td-limit" key="conclusao" :props="props">
            {{props.row.observacaoInterna}}
          </u-td>
          <u-td key="status" :props="props">
            {{Status._getStatus(props.row.status).title}}
          </u-td>
          <u-td key="options" class="text-right" style="max-width: 100px" :props="props">
            <e-btn-table-options>
              <menu-options>
                <list-menu @abrir="abrir(props.row.id)" @edit="edit(props.row.id)"
                           @excluir="excluir(props.row.id)" :leilao="props.row"/>
              </menu-options>
            </e-btn-table-options>
          </u-td>
        </u-tr>
      </u-table>
      <h2 class="diviser"></h2>
      <div v-if="bem.id && !loading" class="m-t">
        <u-btn @click="novo" class="sl-btn" color="positive" no-caps label="Solicitar / Registrar vistoria"/>
      </div>
    </div>
  </div>
</template>

<script>
import CadastroBemMixin from "@/components/bem/components/include/CadastroBemMixin"
import {list} from "@/domain/vistoria/services"
import {listStorage} from "@/components/bem/components/include/vistorias/config/list"
import vistoriaWindow from "@/components/vistoria/windows/vistoria"
import ListMixin from "@/reuse/list/ListMixin"
import * as Status from "@/domain/vistoria/helpers/types"

export default {
  name: "BemVistorias",
  data() {
    return {
      listStorage: this.listStorage,
      loading: false,
      listData: null,
      router: this.bemContainer.router
    }
  },
  components: {
  },
  mounted() {
    this.bem.id && this.load()
  },
  mixins: [CadastroBemMixin, ListMixin],
  watch: {},
  beforeCreate() {
    this.listStorage = listStorage
  },
  computed: {
    Status () {
      return Status
    }
  },
  methods: {
    request({pagination, filter}) {

      this.table.loading = true
      const extraFilters = [
          'bem=' + this.bem.id
      ]
      let filtros = encodeURI(`&sortBy=${pagination.sortBy || 'createdAt'}&descending=${pagination.sortBy ? (pagination.descending ? 'true' : 'false') : true}&${extraFilters.join('')}`)

      list(pagination.rowsPerPage, pagination.page, filtros)
          .then(({data}) => {
            this.table.serverPagination = pagination
            this.table.serverPagination.rowsNumber = data.total
            this.table.serverData = data.result
            this.table.loading = false
          })
          .catch(error => {
            this.alertApiError(error)
            this.loading = false
          })
    },
    vistoriaWindow,
    novo() {
      this.vistoriaWindow(null, this.bem)
    },
    abrir(id) {
      let router = this.$router || this.router
      let routeData = router.resolve({name: 'vistoria.show', params: {id: id}})
      window.open(routeData.href, '_blank')
    },
    excluir(id) {
      this.$uloc.dialog({
        title: 'Excluir registro',
        message: 'Você tem certeza que deseja excluir este registro?',
        ok: 'Sim',
        cancel: 'Não',
        color: 'negative'
      }).then(() => {
        this.$uloc.loading.show({message: 'Deletando...'})
        deleteProcesso(this.bem.id, id)
            .then(() => {
              this.$uloc.loading.hide()
              this.load()
            })
            .catch(error => {
              this.alertApiError(error)
            })
      }).catch(() => {
      })
    }
  }
}
</script>
